import { render, staticRenderFns } from "./CMOverviewExpandedItem.vue?vue&type=template&id=657f2e0a&scoped=true&lang=pug&"
import script from "./CMOverviewExpandedItem.vue?vue&type=script&lang=js&"
export * from "./CMOverviewExpandedItem.vue?vue&type=script&lang=js&"
import style0 from "./CMOverviewExpandedItem.vue?vue&type=style&index=0&id=657f2e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657f2e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
